// extracted by mini-css-extract-plugin
module.exports =  {"toggleableLegend":"style-module_toggleableLegend__e1yag_0wg6jL9PN7z8RU","loading":"style-module_loading__mRLncq8hu0WMhToNX0Oj"};